import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../api/axiosBaseQuery";

export const homeApi: any = createApi({
  reducerPath: "homeApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["posts"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getHomeData: builder.query<any, void>({
      providesTags: ["posts"],
      query: (newPost: any) => ({
        url: `/home?feed_offset=${newPost?.feedOffset || 0}&feed_limit=${
          newPost?.feedLimit || 20
        }&type=${newPost?.feedType || "top"}&topics=${newPost?.topics || ""}`,
        method: "GET",
      }),
    }),
    createPost: builder.mutation<any, void>({
      invalidatesTags: ["posts"],
      query: (newPost) => ({
        url: `/feed/activity`,
        method: "POST",
        data: newPost,
      }),
    }),
    deletePost: builder.mutation({
      invalidatesTags: ["posts"],
      query: (id) => ({
        url: `/feed/activity/${id}/remove`,
        method: "POST",
      }),
    }),
    editPost: builder.mutation({
      invalidatesTags: ["posts"],
      query: ({ id, updatedPost }) => ({
        url: `/feed/activity/${id}/update`,
        method: "POST",
        data: updatedPost,
      }),
    }),
    reportPost: builder.mutation({
      query: ({ data }) => ({
        url: `/feed/activity/report`,
        method: "POST",
        data: data,
      }),
    }),
    addFeedReaction: builder.mutation<any, void>({
      query: (newPost: any) => ({
        url: `/feed/activity/${newPost?.activityId}/reaction`,
        method: "POST",
        data: newPost?.bodyData,
      }),
    }),
    getComments: builder.query<any, void>({
      query: (newPost: any) => ({
        url: `/feed/${newPost?.entityId}/reaction?reaction_offset=${
          newPost?.reactionOffset || 0
        }&reaction_limit=${newPost?.reactionLimit || 5}`,
        method: "GET",
      }),
    }),
    getPost: builder.query({
      query: (id) => ({
        url: `/feed/activity/${id}`,
        method: "GET",
      }),
      transformResponse: (response: any) => response.data,
    }),
    addBookmark: builder.mutation<any, void>({
      query: (newPost: any) => ({
        url: `/feed/activity/${newPost?.activityId}/bookmark`,
        method: "POST",
        data: {},
      }),
    }),
    reportReaction: builder.mutation({
      query: ({ data }) => ({
        url: `/feed/reaction/report`,
        method: "POST",
        data: data,
      }),
    }),
    deleteReaction: builder.mutation({
      query: (id) => ({
        url: `/feed/reaction/${id}/remove`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetHomeDataQuery,
  useCreatePostMutation,
  useLazyGetHomeDataQuery,
  useAddFeedReactionMutation,
  useGetCommentsQuery,
  useLazyGetCommentsQuery,
  useDeletePostMutation,
  useEditPostMutation,
  useAddBookmarkMutation,
  useReportPostMutation,
  useGetPostQuery,
  useReportReactionMutation,
  useDeleteReactionMutation,
} = homeApi;
